import { infoBoxData } from './infoBoxDataHC'


export default infoBoxData
